import React, { Component } from 'react'
import { fontHeight } from '@/components/commons/editor/configs/ElementsConfig'
import styles from './styles.scss'

/** Components */
import IconComponent from '../../commons/IconComponent'


class FontHeight extends Component {
  render() {
    const { onChange, label } = this.props

    return (
      <div className='ba-flex'>
        <IconComponent icon='line-height' />
        <select className={styles['select']}
          value={parseInt(label, 10)}
          onChange={e => onChange(e.target.value)}
        >
          {fontHeight.map(size => (
            <option
              key={size}
              value={size}
            >
              {size} &nbsp;
            </option>
          ))
          }
        </select>
      </div>
    )
  }
}


export default FontHeight



// WEBPACK FOOTER //
// ./src/components/editors/FontHeight/index.js